import React, { ComponentProps, Suspense } from "react";

import TableSkeletonLoader from "components/Progress/TableSkeletonLoader";

const SuspendedComponent =
  <T extends React.LazyExoticComponent<React.ComponentType<any>>>(
    Component: T,
    FallBack: NonNullable<React.ReactNode> | null,
  ) =>
  (props: ComponentProps<T>) => {
    type U =
      T extends React.LazyExoticComponent<React.ComponentType<infer P>>
        ? P
        : never;

    return (
      <Suspense fallback={FallBack ?? <TableSkeletonLoader />}>
        <Component {...props} />
      </Suspense>
    ) as unknown as U;
  };

export default SuspendedComponent;
